<template>
    <div>
        <div class="tabs__filters tabs__filters--space-between d-flex">
            <div class="tabs__filters-wrapper d-flex">
                <date-picker class="tabs__filters-item" v-model="timeFrom" value-type="format" format="YYYY-MM-DD HH:mm:ss" @change="getNotifications"  :placeholder="$store.getters.t('tab_notice_from_date')"></date-picker>
                <date-picker class="tabs__filters-item" v-model="timeTo" value-type="format" format="YYYY-MM-DD HH:mm:ss" @change="getNotifications" :placeholder="$store.getters.t('tab_notice_to_date')"></date-picker>
            </div>
            <button href="#" class="btn btn--sm btn--rounded" @click.prevent="markAsRead('interactive')"
               v-if="type === 'INTERACTIVE'" :disabled="! notifications.length || this.marked
               ||! this.notifications.find( e => e.status === 'unread' && e.type !== 'broadcast' )">
               {{$store.getters.t('tab_notice_mark_as_read')}}
            </button>
        </div>
        <div class="notice">

            <template v-if="type === 'INFO'">

                <div v-if="notifications.length">
                    <div class="notice__list" v-if="!loading">

                        <notice-info @refreshTab="refreshNotification" :notice="notice" v-for="(notice, index) in notifications" :key="index"/>

                    </div>
                    <div class="notice__list d-flex" v-else>

                        <div class="profile-pets__body-content profile-pets__body-content d-flex">
                            <div class="LoaderBalls">
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="notice__list notice__list-empty d-flex" v-else>
                    {{$store.getters.t('tab_notice_list_empty')}}
                </div>

            </template>

            <template v-if="type === 'INTERACTIVE'">

                <div v-if="notifications.length">
                    <div class="notice__list" v-if="!loading">

                        <notice-moderation @refreshTab="refreshNotification" :user="user" :notice="notice" v-for="(notice, index) in notifications" :key="index"/>

                    </div>
                    <div class="notice__list d-flex" v-else>

                        <div class="profile-pets__body-content profile-pets__body-content d-flex">
                            <div class="LoaderBalls">
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="notice__list notice__list-empty d-flex" v-else>
                    {{$store.getters.t('tab_notice_list_empty')}}
                </div>
            </template>



            <template v-if="type === 'PAYMENTS'">
                <div v-if="notifications.length">
                    <div class="notice__list" v-if="!loading">

                        <notice-payments @refreshTab="refreshNotification" :notice="notice" v-for="(notice, index) in notifications" :key="index"/>

                    </div>
                    <div class="notice__list d-flex" v-else>

                        <div class="profile-pets__body-content profile-pets__body-content d-flex">
                            <div class="LoaderBalls">
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="notice__list notice__list-empty d-flex" v-else>
                    {{$store.getters.t('tab_notice_list_empty')}}
                </div>
            </template>


        </div>



        <div class="row" v-if="pageCount > 1">
            <div class="col-md-12">
                <div class="pagination-area">
                    <nav class="navigation pagination" role="navigation">
                        <div class="nav-links">
                            <paginate
                                v-model="page"
                                :page-count="pageCount"
                                :click-handler="paginateClickCallback"
                                :prev-text="''"
                                :next-text="''"
                                :container-class="'className'"
                                :page-class="'page-numbers'"
                                :page-link-class="''"
                                :active-class="'current'"
                                :prev-class="'prev page-numbers'"
                                :prev-link-class="'lnr lnr-arrow-left'"
                                :next-class="'next page-numbers'"
                                :next-link-class="'lnr lnr-arrow-right'"
                            >
                            </paginate>
                        </div>
                    </nav>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { mapActions } from 'vuex'

import DatePicker from 'vue2-datepicker';
import TabSelect from '../TabSelect';
import NoticeInfo from './NoticeInfo';
import NoticeModeration from './NoticeModeration';
import NoticePayments from './NoticePayments';
import 'vue2-datepicker/index.css';
export default {
    name: "TabNotice",
    props: ['type', 'user'],
    inject: ['isActive'],
    components: {
        DatePicker,
        TabSelect,
        NoticeInfo,
        NoticeModeration,
        NoticePayments,

    },
    data(){
        return{
            moment: window.moment,
            notifications: [],
            pageCount: 2,
            page: 1,
            timeFrom: null,
            timeTo: null,
            loading: false,
            marked: false,
        }
    },

    mounted(){
        this.getNotifications();
    },

    computed: {
        isActiveTab(){
            return this.isActive();
        },

        markedConditional(){
            return (
                ! this.marked && this.isActiveTab && this.notifications.length
                && ( this.type === 'INFO' ||  this.type === 'PAYMENTS' )
                && !! this.notifications.find( e => e.status === 'unread' && e.type !== 'broadcast' )
            )
        }
    },

    methods:{
        ...mapActions(['fetchNotifications']),
        markAsRead( cat ){

            if( this.marked ) return;

            try{

                const params = { category: cat.toLowerCase() }
                axios.post( '/api/notifications-mark-as-read', params )
                    .then( ({ data: { success = false } }) => {
                        if( success ) this.marked = true;
                    })

            }
            catch ( _e ) {

                console.log( _e );

            }


        },
        refreshNotification(){
            this.page = 1;
            this.getNotifications()
            this.fetchNotifications()
        },
        paginateClickCallback(pageNum) {
            this.page = pageNum;
        },
        getNotifications(){
            let url = '/api/notifications',
                type = this.type.toLowerCase(),
                since = this.timeFrom,
                till = this.timeTo


            let params = {
                category : type,
                page: this.page,
                since: since,
                till: till
            };

            axios.get(url,{params: params})
                .then(response =>{
                    response = response.data
                    if(response){
                        this.notifications = response.data
                        this.pageCount = response.meta.last_page


                    }
                })
                .catch()
        },

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    },
    watch:{

        isActiveTab( val ){

            if( ! val ) return;

            if( this.markedConditional ) {
                this.markAsRead( this.type )
            }

        },

        page() {
            this.getNotifications();
        },

        notifications() {
            this.loading = true;
            setTimeout(()=>{
                this.loading = false
            },1000);

            if( this.markedConditional ) {
                this.markAsRead( this.type )
            }

        },

    }
}
</script>

<style lang="scss">




</style>
